import Api from '@/services/Api'

export default {
	getFechasCentroCostosByContrato(nroContrato){
        return Api().get('/contratoCentroCostos/getVigenciasCentroCostoByContrato/'+nroContrato)
    },
	leaContratoCentroCostos(numContrato){
		return Api().get('contratoCentroCostos/leaContratoCentroCostos/'+numContrato)
	},
	adicionaCentroCosto(info) {
		return Api().put('contratoCentroCostos/adicionaCentroCosto',info)
	},
	consultaCentroCostoById(id){
		return Api().get('contratoCentroCostos/consultaContratoCentroCosto/'+id)
	},
	updateContratoCentroCosto(info) {
		return Api().put('contratoCentroCostos/updateContratoCentroCosto',info)
	},
	newPlantillaContratoCentroCosto(info) {
		return Api().post('contratoCentroCostos/insertNewPlantillaContratoCentroCosto',info)
	},
	deletPorcentajeCentroCosto(id) {
		return Api().delete('contratoCentroCostos/deletPorcentajeCentroCosto/'+id)
	},
}
